import { PageController } from '@client/components/_core/layout/PageController';
import { PolicyConnectionsSection } from '@client/components/document-sources/PolicyConnectionsSection';
import { ORG_ROLES } from '@shared/constants/business/user';
import { PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute } from '@tanstack/react-router';
import { BookText } from 'lucide-react';

/**
 * Policy sources (CUR-2566): the policy administration systems, INSIGHT for now, that auditors find
 * policies and authorised representatives in. Read only: Curium support adds the connections and
 * changes their credentials in the System Console. A page of its own, behind its own flag, so an
 * organisation can read policies without connecting Microsoft 365 (INSIGHT plan, "Feature flag").
 */
export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/policy-sources')({
    staticData: {
        presentation: 'page',
        breadcrumb: { title: 'Policy sources' },
        ui: {
            icon: BookText,
            title: 'Policy sources',
            subtitle:
                'The policy systems auditors find policies and authorised representatives in for compliance audits',
            menuDescription:
                'The policy systems auditors find policies and authorised representatives in for compliance audits.',
        },
        // As on Document sources: the server also needs `enable-compliance-audit`, which a route
        // cannot add as a second flag; this flag is only switched on where compliance audits are.
        featureFlag: 'enable-audit-policy-sources',
        modules: ['compliance-audit'],
        // The server gate needs `compliance_audit:manage` AND `settings:update`; a route's
        // `permissions` list is OR, so the settings half is carried by the `org_admin` role.
        roles: [ORG_ROLES.ORG_ADMIN],
        permissions: [PERMISSIONS.COMPLIANCE_AUDIT_MANAGE],
    },
    component: PolicySourcesPage,
});

function PolicySourcesPage() {
    return (
        <PageController route={Route}>
            <PolicyConnectionsSection />
        </PageController>
    );
}
